import {ChangeDetectionStrategy, Component, Input} from '@angular/core'

/**
 * Allows to display a breadcrumb trail.
 * For all elements, except the last one, you should provide a link or a navigateFn, otherwise you probably shouldn't be using breadcrumbs.
 */
export interface Breadcrumb {
  name: string
  link?: string
  //allows to use the breadcrumb dynamically e.g. dynamic content changes within one page (without route changes)
  navigateFn?: () => void
}

@Component({
  selector: 'cft-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference '../../../styles/app-reference.css';

    :host {
      display: block;
    }
    :host-context(cft-dashboard) .back-button {
      @apply sticky left-0 bg-linear-to-r from-grey-50 from-60% sm:bg-none;
    }
    :host-context(cft-dashboard) :host {
      @apply max-w-[calc(_100%_-3rem)];
    }
  `,
})
export class BreadcrumbsComponent {
  @Input() set breadcrumbs(breadcrumbs: Breadcrumb[]) {
    this.currentBreadcrumb = breadcrumbs[breadcrumbs.length - 1]
    this.previousBreadcrumbs = previousBreadcrumbs(breadcrumbs)
    this.previousBreadcrumb = this.previousBreadcrumbs[this.previousBreadcrumbs.length - 1]
  }

  currentBreadcrumb!: Breadcrumb
  previousBreadcrumb!: Breadcrumb
  previousBreadcrumbs!: Breadcrumb[]

  /** Light style is appropriate when the background is dark, making the breadcrumbs white */
  @Input() light = false
  @Input() showBackButton = true

  navigate(breadcrumb: Breadcrumb): void {
    if (breadcrumb.navigateFn) {
      breadcrumb.navigateFn()
    }
  }
}

function previousBreadcrumbs(crumbs: Breadcrumb[]): Breadcrumb[] {
  const previous = [...crumbs]
  previous.pop()
  return previous
}
